/* ═══════════════════════════════════════════════════════════════
   Collection controls.

   Two behaviours, both of which the page already works without:

     · [data-gmd-go]    a <select> whose option values are URLs —
                        changing it navigates. Without JS the same
                        destinations are reachable from the plain
                        links the section renders in <noscript>.
     · [data-gmd-sort]  a <select> inside a real GET form. Without JS
                        the form's own submit button does the job; with
                        JS the button is redundant, so changing the
                        select submits and the button never appears.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function init(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-gmd-go]').forEach(function (select) {
      if (select.dataset.gmdReady) return;
      select.dataset.gmdReady = '1';
      select.addEventListener('change', function () {
        if (select.value) window.location.href = select.value;
      });
    });

    root.querySelectorAll('[data-gmd-sort]').forEach(function (select) {
      if (select.dataset.gmdReady) return;
      select.dataset.gmdReady = '1';
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
